<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Liste des candidatures à une formation">
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="idCampusSelect"
              label="Campus"
              :items="campus"
              item-value="id"
              item-text="libelle"
              @change="getFormations()"
            >
            </v-select>
            <v-combobox
              v-model="select"
              :items="formations"
              :item-text="displayItem"
              item-value="id"
              @change="getCandidatures"
              :label="inviteFormations"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="candidatures"
              disable-pagination
              hide-default-footer
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              item-key="id"
              class="elevation-1"
              :custom-sort="customSort"
              :search="search"
            >
              <template v-slot:[`item.uid`]="{ item }">
                <v-icon v-if="item.uid" :color="colorUnivLille"
                  >mdi-alpha-l-circle</v-icon
                >
              </template>
              <template v-slot:[`item.nom`]="{ item }">
                <v-tooltip
                  v-if="item.uid"
                  bottom
                  max-width="20%"
                  :color="colorUnivLille"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.nom }}</span>
                  </template>
                  <span>Étudiant interne</span>
                </v-tooltip>
                <v-tooltip v-else bottom max-width="20%">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.nom }}</span>
                  </template>
                  <span>Étudiant externe</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.etatDemande`]="{ item }">
                {{ item.etatDemande.libelle }}
                <span v-if="item.etatDemande.id == ETAT.CONFIRMEE.code">
                  le {{ item.dateConfirmation }}</span
                >
                <span v-if="item.etatDemande.id == ETAT.FINALISEE.code">
                  le {{ item.dateFinalisation }}</span
                >
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <router-link
                  :to="{
                    name: 'detail-candidature',
                    params: { idCandidature: item.id },
                  }"
                >
                  <v-icon class="mr-2" title="Visualiser la candidature"
                    >mdi-eye</v-icon
                  >
                </router-link>
              </template>
              <template v-slot:top>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Recherche"
                    single-line
                    hide-details
                    class="mx-5"
                  ></v-text-field>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import ListingSort from "@/js_modules/ListingSort";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";

export default {
  name: "ListeCandidaturesScolarite",
  components: { BaseBlock },
  mixins: [EtatDemande],
  data() {
    return {
      sortBy: "etatDemande",
      sortDesc: false,
      idCampusSelect: "",
      campus: [],
      select: [],
      formations: [],
      search: "",
      idFormation: null,
      candidatures: [],
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "uid",
        },
        {
          text: "Nom",
          align: "left",
          sortable: true,
          value: "nom",
        },
        {
          text: "Prénom",
          align: "left",
          sortable: true,
          value: "prenom",
        },
        {
          text: "Date de naissance",
          align: "center",
          sortable: true,
          value: "dateNaissance",
        },
        {
          text: "Date de dépôt",
          align: "center",
          sortable: true,
          value: "dateDepot",
        },
        {
          text: "Etat de la demande",
          align: "center",
          sortable: true,
          value: "etatDemande",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ],
      colorUnivLille: "#1f8388",
    };
  },
  watch: {
    idCampusSelect() {
      if (this.idCampusSelect != undefined) {
        sessionStorage.lcscolCampusFiltre = this.idCampusSelect;
      }
    },
    select() {
      if (this.select != undefined) {
        sessionStorage.lcscolFormationFiltre = this.select.id;
      }
    },
  },
  async created() {
    this.getCampus();
  },
  methods: {
    displayItem(item) {
      let nbCandidaturesATraiter = item.nbCandTrait;
      if (nbCandidaturesATraiter > 0) {
        return item.libelle + " (" + nbCandidaturesATraiter + ")";
      } else {
        return item.libelle;
      }
    },
    customSort: function (items, index, isDesc) {
      return ListingSort.sortScolariteColumns(items, index, isDesc);
    },
    async getCandidatures() {
      if (
        this.select != null &&
        this.select !== undefined &&
        this.select.id !== undefined
      ) {
        try {
          const candidatures = await ApiCandidatureRepository.getCandidatures(
            this.select.id
          );
          this.candidatures = candidatures;
        } catch (error) {
          this.$toast.error(error.response.data.messages[0]);
        }
      }
    },
    async getCampus() {
      try {
        const campus = await ApiCampusRepository.getCampusLst();
        this.campus = campus;
        if (sessionStorage.lcscolCampusFiltre) {
          /*
          let campus = this.campus.find(
            x => x.id == sessionStorage.lcscolCampusFiltre
          );
          this.idCampusSelect = campus.id;
          */
          this.idCampusSelect = Number(sessionStorage.lcscolCampusFiltre);
        } else {
          this.idCampusSelect = this.campus[0].id;
        }
        this.getFormations();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getFormations() {
      try {
        this.candidatures = [];

        const formations = await ApiFormationRepository.getFormationsScolarite(
          this.idCampusSelect
        );
        this.formations = formations;

        if (sessionStorage.lcscolFormationFiltre) {
          this.select = this.formations.find(
            (x) => x.id == sessionStorage.lcscolFormationFiltre
          );
          if (!this.select) {
            this.select = this.formations[0];
          }
        } else {
          this.select = this.formations[0];
        }
        this.getCandidatures();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  computed: {
    inviteFormations() {
      if (this.formations.length > 0) {
        return "Sélectionnez une formation";
      } else {
        return "Aucune formation avec des candidatures confirmées ou finalisées";
      }
    },
  },
};
</script>
